import Plausible from "plausible-tracker";
const { trackEvent, trackPageview, enableAutoOutboundTracking } = Plausible({
	domain: "informatiktage.ch"
});
export { trackEvent, trackPageview, enableAutoOutboundTracking };
